export default "__VITE_ASSET__DIqoRJpS__"